import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#F5F0E8] pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-47">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#FDFBF7] skew-x-12 translate-x-20 opacity-50 hidden lg:block" data-id="element-48" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-49">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-50">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-51">
            <div className="inline-block px-4 py-1 mb-6 border border-[#C5A55A] text-[#C5A55A] text-xs font-bold tracking-widest uppercase rounded-full bg-white/50 backdrop-blur-sm" data-id="element-52">
              Para emprendedoras que venden por Instagram y WhatsApp
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#2D2D2D] leading-tight mb-6" data-id="element-53">
              Convertí tus DMs en{' '}
              <span className="text-[#C5A55A] italic" data-id="element-54">ventas</span> sin rogar ni
              perder tiempo
            </h1>

            <p className="text-lg md:text-xl text-[#6B6B6B] mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-55">
              El kit con 30 scripts listos para copiar, pegar y cerrar. Basado
              en el Mapa de Conversación 5F.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-6" data-id="element-56">
              <Button size="lg" icon href="https://www.mujerdigital2.com/cart/42527848693847:1" data-id="element-57">
                QUIERO EL KIT AHORA
              </Button>
            </div>

            <p className="text-xs text-[#6B6B6B] uppercase tracking-wide flex items-center justify-center lg:justify-start gap-2" data-id="element-58">
              <CheckCircle2 className="w-4 h-4 text-[#C5A55A]" data-id="element-59" /> Acceso
              inmediato
              <span className="text-[#C5A55A]" data-id="element-60">•</span>
              <CheckCircle2 className="w-4 h-4 text-[#C5A55A]" data-id="element-61" /> Formato
              digital
              <span className="text-[#C5A55A]" data-id="element-62">•</span>
              <CheckCircle2 className="w-4 h-4 text-[#C5A55A]" data-id="element-63" /> Garantía 7
              días
            </p>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-64">
            <div className="absolute inset-0 bg-[#C5A55A] rounded-2xl transform rotate-3 opacity-20 blur-xl" data-id="element-65" />
            <img src="https://cdn.magicpatterns.com/uploads/mrFwVbbMWhQTCogyLvHdf5/heylloyd-image-1770585387001.png" alt="Kit DM Que Cierra en Tablet" className="relative rounded-lg shadow-2xl w-full max-w-md mx-auto lg:max-w-full border-4 border-white" data-id="element-66" />
          </motion.div>
        </div>
      </div>
    </section>;
}